<template>
  <div class="book-detail-modal">
    <div class="modal-content">
      <h3>{{ book.name }}</h3>
      <img :src="book.cover" alt="Capa do PDF" style="max-width: 200px;" />
      <p><strong>Categoria:</strong> {{ book.category || 'Categoria não disponível' }}</p>
      <p><strong>Quantidade de Páginas:</strong> {{ book.pageCount || 0 }}</p>
      <button class="btn-close" @click="$emit('close')">Fechar</button>
    </div>
  </div>
</template>

<script>
import '../styles/BookDetail.css';
export default {
  name: 'BookDetail',
  props: {
    book: {
      type: Object,
      required: true
    }
  }
}
</script>

